import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApprovalRule } from '../../models/common/setting-area.model';

@Component({
    selector: 'app-add-new-rule',
    templateUrl: './add-new-rule.component.html',
    styleUrls: ['./add-new-rule.component.scss'],
    standalone: false
})
export class AddNewRuleComponent implements OnInit {
    addRuleFormGroup: UntypedFormGroup;
    selectedRule: ApprovalRule;
    constructor(
        private ngbActiveModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder
    ) {}

    createFormControls() {
        this.addRuleFormGroup = this.formBuilder.group({
            name: [this.selectedRule?.name ? this.selectedRule?.name : '', [Validators.required]],
        });
    }

    ngOnInit(): void {
        this.createFormControls();
    }

    closeClick() {
        this.ngbActiveModal.close();
    }

    addButtonClick() {
        if (this.addRuleFormGroup.valid) {
            if (this?.selectedRule) {
                this.selectedRule.name = this.addRuleFormGroup.get('name').value;
                this.ngbActiveModal.close(this.selectedRule);
            } else {
                let selectedRule: ApprovalRule = {
                    approvalRuleId: '0',
                    name: this.addRuleFormGroup.get('name').value,
                    enabled: true,
                };
                this.ngbActiveModal.close(selectedRule);
            }
        }
    }
}
